module.exports = __webpack_public_path__ + "img/164w.f29450a.jpg";